var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import { H5 } from "@irati/ui/src/Headings";
import { InlineBold } from "./styled";
var Step1Content = /** @class */ (function (_super) {
    __extends(Step1Content, _super);
    function Step1Content() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Step1Content.prototype.render = function () {
        var boldText = (React.createElement(InlineBold, null,
            React.createElement(FormattedMessage, { id: "setup_tenant.tour.step1.boldText" })));
        return (React.createElement(React.Fragment, null,
            React.createElement(H5, { tiny: true, bold: true },
                React.createElement(FormattedMessage, { id: "setup_tenant.tour.step1.title" })),
            React.createElement(Para, null,
                React.createElement(FormattedMessage, { id: "setup_tenant.tour.step1.content", values: { boldText: boldText } }))));
    };
    return Step1Content;
}(PureComponent));
export default Step1Content;
